import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
    modal: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        padding: "32px",
        width: "90%",
        maxWidth: "420px",
        textAlign: "center",
    },
    heading: {
        marginBottom: "12px",
    },
    subtext: {
        marginBottom: "24px",
        color: "#666",
    },
    otpBox: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
    },
    otpInput: {
        width: "48px",
        height: "48px",
        textAlign: "center",
        fontSize: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",

        "@media (max-width: 400px)": {
            width: "36px",
            height: "42px",
            fontSize: "18px",
        },

        "@media (max-width: 320px)": {
            width: "32px",
            height: "40px",
            fontSize: "16px",
        },
    },
    resend: {
        fontSize: "14px",
        color: "#3f51b5",
        marginBottom: "20px",
        userSelect: "none",
    },
    backHome: {
        fontSize: "14px",
        color: "#3f51b5",
        marginTop: "10px",
        userSelect: "none",
    },
    validateButton: {
        width: "100%",
        padding: "12px 0",
        fontSize: "16px",
    },
    backHomeButton: {
        width: "100%",
        padding: "12px 0",
        fontSize: "16px",
        marginTop: "24px",
    },
});
